<template>
  <div class="product">
     <header>
    <Navbar />
    </header>
    <div class="product-header">
      <!-- <div class="productBanner">
        <img :src="operaingBanner" />
      </div> -->
      <div class="product_bannnerText">
        <div>智慧运营管理</div>
        <div>
          基于新技术研发的新一代医院信息平台系统，体现了“以患者为中心”的管理念，促进
          医院资源在临床医疗和管理运营中的高效配置利用。
        </div>
      </div>
    </div>
    <div class="productCont">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right;">
          <el-breadcrumb-item :to="{ path: '/productCenter' }"
            >产品中心 > 智慧运营管理 >
          </el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===1">财务一体化管理平台 </el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===2">全面预算管理系统</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===3">成本核算管理系统</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===4">物资管理系统</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===5">固定资产管理系统 </el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===6">人力资源管理系统</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===7">绩效管理系统</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===8">经济运营分析平台</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===9">区域卫生经济运营监控分析平台 </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="tabs" style="background-color: #ffffff">
        <div class="tabsCont">
          <el-radio-group v-model="tabPosition" style="margin-bottom: 30px">
          </el-radio-group>

          <div class="tabTitle">
            <div>产品导航</div>
            <div>展华HRP系统</div>
          </div>
          <el-tabs :tab-position="tabPosition" class="a">
            <el-tab-pane>
              <span slot="label" @click="tab(1)">
                <i class="el-icon-caret-right"></i> 财务一体化管理平台
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">财务一体化管理平台</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">展华HRP系统简介</div>
                    <div class="outpatientContText">
                      展华HRP系统融合诸多国际先进的、符合国情现状的医院管理理念，为医院构建起一整套以财务管理为核心、预算管理为主线，资产、成本管理为基础，绩效薪酬管理为杠杆的运营管理系统，实现医院运营管理中的“物流、资金流、信息流、控制流”的统一，增强对人、财、物各项综合资源的计划、使用、协调、控制、评价和激励等方面的管理。
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">
                      财务一体化管理平台简介
                    </div>
                    <div class="outpatientContText">
                      完全依据政府会计制度的要求，遵循“财务会计和预算会计适度分离并相互衔接”的会计核算模式，全面准确反映医院的预算执行信息和财务信息；以各业务系统提供的数据作为原始凭证，以会计核算为中心，自动生成会计凭证，实现完整的财务管控体系，保证数据传导的准确性，真正起到财务的管控作用，为医院财务部门实现管理角色的转换提供保障。
                      <br />为医院经济运营管理量身打造，具有专业性、针对性、准确性等特点，为医院运营决策提供更加精准的信息。从客户实际需求出发，系统采用成熟的技术研发语言，易用性强，可快速投入使用。
                    </div>
                    <div class="outpatientImg">
                      <img :src="operaingFinance" />
                      <div class="line">— 财务管理系统截图 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="trait">
                      <li>凭证自动生成</li>
                      <li>核算项目备查簿</li>
                      <li>往来自动核销</li>
                      <li>账簿管理</li>
                      <li>报表生成</li>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" @click="tab(2)">
                <i class="el-icon-caret-right"></i> 全面预算管理系统
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">全面预算管理系统</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">全面预算管理系统简介</div>
                    <div class="outpatientContText">
                      以医院总体战略为中心，按照全方位、全过程、全员、全额的管理观念，建立全面预算管理的立体管控体系；按照事前、事中、事后管理过程，强化全面预算管理系统的全程控制；按照上下结合的方式，实现全面预算管理系统的双向管理；按照预算管理职能，构建全面预算管理系统四层架构；按照预算管理范围，建立全面预算管理系统多维模型，在每个环节都设立管控指标，实现全面预算的闭环管理。
                    </div>
                    <div class="outpatientImg">
                      <img :src="operainBudgetg" />
                      <div class="line">— 电子病历系统截图 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="trait">
                      <li>年初编制</li>
                      <li>预算执行</li>
                      <li>预算调整</li>
                      <li>预算报表</li>
                      <li>预算考评</li>
                    </div>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
            <el-tab-pane
              ><span slot="label" @click="tab(3)"
                ><i class="el-icon-caret-right"></i> 成本核算管理系统</span
              >
              <div class="outpatient">
                <div class="outpatientTitle">成本核算管理系统</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">医院科室成本核算管理系统简介</div>
                    <div class="outpatientContText">
                      从医院全成本核算入手，按照管理科室、医辅科室、科研教学科室、医技科室、临床科室归集，采用分项、逐级、分布结转的方法进行成本分摊，是责任成本与医疗成本的结合点，不仅关注成本结果，也关注成本形成过程；利用HIS和财务管理系统中与成本核算管理系统有关的数据，通过接口设计实现数据转换，轻松实现医院各级成本项目的管理、分析及控制，更新医院经济管理的观念，提高医院全体员工的成本控制意识，减少浪费，切实提高医院的社会效益和经济效益，进而增强医院在市场经济条件下的竞争能力。
                      <br />应用多种财务分析模型，对医院的经营状况进行分析预测。如：比较分析、趋势分析、本量利分析模型等。
                    </div>
                    <div class="outpatientImg">
                      <img :src="operaingCosta" />
                      <div class="line">— 医院科室成本核算管理系统截图 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">
                      医院科室成本核算管理系统简介
                    </div>
                    <div class="outpatientContText">
                      医疗项目成本核算是以各科室开展的医疗服务项目为对象，归集和分配费用，利用价值比价比例来分配实际科室成本计算出各项目单位成本的过程。计算医疗项目成本可以为制定和调整医疗收费标准以及国家对医院实行的补贴提供可靠的依据，同时可为服务定价、投资论证、付费偿还、效益评估等提供支撑。
                    </div>
                    <div class="outpatientImg">
                      <img :src="operaingCostb" />
                      <div class="line">— 成本核算数据 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">
                      医院科室成本核算管理系统简介
                    </div>
                    <div class="outpatientContText">
                      病种成本核算是以病种、病组为对象，在科室成本核算的基础上，以对病人救治全过程中的医疗资源消耗为核心的精细化成本核算。核算过程中在临床治疗流程上建立成本账户，以提高病种成本核算的准确性、灵活性。
                    </div>
                    <div class="outpatientImg">
                      <img :src="operaingCostc" />
                      <div class="line">— 病种成本核算系统截图 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="trait">
                      <li>数据提取</li>
                      <li>核算设置</li>
                      <li>分摊计算</li>
                      <li>报表分析</li>
                    </div>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
            <el-tab-pane style="height: 660px">
              <span slot="label" @click="tab(4)">
                <i class="el-icon-caret-right"></i> 物资管理系统
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">物资管理系统</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">物资管理系统简介</div>
                    <div class="outpatientContText">
                      系统支持物资的全条码化管理，在物资验收、入库、出库、消耗使用等所有环节均支持扫描条码快速录入。支持物资多种管理模式（零库存管理、供应商备货、第三方物流等），帮助医院减少库存资金积压，系统设有预警提醒，提升物资管理整体水平。实现高值耗材从备货入库、领用、使用、收费、入库、出库、结算等各个环节的全程可追溯管理，保障医疗安全。
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="trait">
                      <li>采购计划</li>
                      <li>出入库管理</li>
                      <li>盘点</li>
                      <li>条形码管理</li>
                      <li>对账</li>
                      <li>月末结账</li>
                      <li>报表</li>
                    </div>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
            <el-tab-pane>
              <span slot="label" @click="tab(5)">
                <i class="el-icon-caret-right"></i> 固定资产管理系统
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">固定资产管理系统</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">固定资产管理系统简介</div>
                    <div class="outpatientContText">
                      实现医疗设备从科室申购（年度预算、临时采购预算）、审批、招标、安装验收、入出库、维修、预防性维护，到报废处置的全生命周期的规范化管理，更好的保障临床使用，满足医疗设备管理的高标准要求。
                    </div>
                  </div>
                  <div class="outpatientImg">
                    <img :src="operaingFinance" />
                    <div class="line">— 财务管理系统截图 —</div>
                  </div>

                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="traits">
                      <li>基础设置</li>
                      <li>采购管理</li>
                      <li>合同管理</li>
                      <li>卡片管理</li>
                      <li>资产变动</li>
                      <li>资产盘点</li>
                      <li>设备维修</li>
                      <li>仪器校验</li>
                      <li>效益分析</li>
                      <li>投资决策</li>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" @click="tab(6)">
                <i class="el-icon-caret-right"></i> 人力资源管理系统
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">人力资源管理系统</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">人力资源管理系统简介</div>
                    <div class="outpatientContText">
                      系统针对医院人员招聘、劳动合同、薪酬福利、考勤、调动等人事环节进行管理，根据人员的排班、考勤情况自动计算薪酬、福利、公积金、保险等各工资相关项。医院管理部门可以及时根据人事统计数据进行科学决策。
                    </div>
                    <div class="outpatientImg">
                      <img :src="operaingHuman" />
                      <div class="line">—  人力资源管理系统截图  —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="traits">
                      <li>人事档案</li>
                      <li>合同管理</li>
                      <li>薪酬管理</li>
                      <li>年度考核</li>
                      <li>职称评定</li>
                      <li>考勤管理</li>
                      <li>排班管理</li>
                      <li>招聘管理</li>
                      <li>培训管理</li>
                      <li>人事统计与分析</li>
                    </div>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
            <el-tab-pane style="height: 660px">
              <span slot="label" @click="tab(7)">
                <i class="el-icon-caret-right"></i> 绩效管理系统
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">绩效管理系统</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">绩效管理系统简介</div>
                    <div class="outpatientContText">
                      通过构建基于平衡计分卡和行为锚定法的医院绩效管理系统，结合DRG/DIP付费支付改革、病种成本核算，使医院的目标管理与绩效管理相结合，形成一个能够贯穿医院所有管理方面工作同时又与医院管理目标相一致的管理体系，以提升医院管理能力，使医院的管理步入规范化、精细化管理的轨道上来。
                    </div>
                    
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="trait">
                      <li>方案编制</li>
                      <li>KPI维护/li>
                      <li>数据获取</li>
                      <li>绩效核算</li>
                      <li>报表分析</li>
                    </div>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
            <el-tab-pane>
              <span slot="label" @click="tab(8)">
                <i class="el-icon-caret-right"></i> 经济运营分析平台
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">经济运营分析平台</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">经济运营分析平台简介</div>
                    <div class="outpatientContText">
                      建设医院监管指标体系，以综合运营管理各子系统提供的数据为依据，期末系统自动生成经济运营分析报告，及时掌握医院各方面的动态变化，实时汇总运营管理所需要的信息，实现网络化实时动态监管，从而有效、快速发现问题，为管理者提供真实、全面、有效的决策参考数据，提高管理部门决策管理能力。
                    </div>
                     <div class="outpatientImg">
                      <img :src="operingManagement" />
                      <div class="line">—  经济运营分析平台截图  —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="trait">
                      <li>数据挖掘</li>
                      <li>综合分析</li>
                      <li>因素分析</li>
                      <li>投资决策</li>
                      <li>经营预测</li>
                    </div>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
                <el-tab-pane>
              <span slot="label" @click="tab(9)">
                <i class="el-icon-caret-right"></i> 区域卫生经济运营监控分析平台
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">区域卫生经济运营监控分析平台</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">区域卫生经济运营监控分析平台简介</div>
                    <div class="outpatientContText">
                      按照“统一规划、集中监管、信息共享、互联互通”的模式，实现局端和院端系统的交互对接，形成以区域端管理系统为依托，以医院端各业务系统为支撑的监管模式，强化卫健委对各医院的业务管理职能和宏观调控职能，提高财政资金使用的计划性和可监管性，实时、准确收集医院的综合信息进行分析，为区域卫生经济运营决策提供支持。
                    </div>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <footer>
    <Root/>
    </footer>
  </div>
</template>
<script src="//unpkg.com/vue/dist/vue.js"></script>
<script src="//unpkg.com/element-ui@2.15.7/lib/index.js"></script>
<script>
import Navbar from "../../layout/Navbar.vue";
import Root from "../../layout/root.vue"
import operaingBanner from "../../assets/operaingBanner.png";
import operaingFinance from "../../assets/operaingFinance.png";
import operainBudgetg from "../../assets/operainBudgetg.png";
import operaingCosta from "../../assets/operaingCosta.png";
import operaingCostb from "../../assets/operaingCostb.png";
import operaingCostc from "../../assets/operaingCostc.png";
import operaingHuman from "../../assets/operaingHuman.png"
import operingManagement from "../../assets/operingManagement.png"
export default {
  name: "operaing",
  components: {
    Navbar,Root,
  },
  data() {
    return {
      current:1,
      tabPosition: "left",
      operaingBanner: operaingBanner,
      operaingFinance: operaingFinance,
      operainBudgetg: operainBudgetg,
      operaingCosta: operaingCosta,
      operaingCostb: operaingCostb,
      operaingCostc: operaingCostc,
      operaingHuman:operaingHuman,
      operingManagement:operingManagement,
    };
  },
  methods: {
     tab(index){
      this.current=index;
    },
  },
};
</script>
<style scoped>
@import url("//unpkg.com/element-ui@2.15.7/lib/theme-chalk/index.css");
footer{
  height: 520px;
  margin-top: 30px;
}
header{
 background-color: #ffffff;
}
.product {
  background-color: #f5f7fa;
  width: 100%;
  overflow: hidden;
  font-family: PingFangSC-Medium;
}
.product-header {
  position: relative;
  height: 420px;
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/operaingBanner.png") no-repeat;
  background-position:center;
  background-size: cover;
}
/* .productBanner {
  width: 1920px;
  left: 50%;
  margin-left: -960px;
  position: relative;
} */
.product_bannnerText {
  position: absolute;
  left: 7.5%;
  top: 113px;
}
.product_bannnerText :nth-child(1) {
  font-size: 52px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.product_bannnerText :nth-child(2) {
  width: 64%;
  font-size: 18px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 200;
  margin-top: 33px;
}
.productCont {
  width: 85%;
  margin: 0 auto;
}
.crumbs {
  margin-top: 25px;
  margin-bottom: 30px;
}
.crumbs .el-breadcrumb {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 22px;
  font-weight: 400;
}
.tabsCont {
  width: 95%;
  margin: 0 auto;
  position: relative;
}
.tabTitle {
  position: absolute;
  top: 35px;
  z-index: 100;
  width: 20%;
}
.tabTitle :nth-child(1) {
  font-size: 20px;
  margin: 0 auto;
  height: 50px;
  border-bottom: 1px solid #e9eaee;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.tabTitle :nth-child(2) {
  font-size: 16px;
  color: #0f1422;
  letter-spacing: 0;
  margin-top: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}
.outpatient {
  width: 95%;
  margin: 0 auto;
}
.outpatientTitle {
  font-size: 28px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  height: 55px;
  border-bottom: 1px solid #e9eaee;
}
.outpatientConBox {
  width: 100%;
  margin: 0 auto;
}
.outpatientImg {
  width: 100%;
  text-align: center;

  margin: 0 auto;
}
.outpatientImg img {
  margin-top: 50px;
}
.tabs .el-tabs {
  height: 100% !important;
}
.outpatientContTitle {
  font-size: 20px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 50px;
  margin-bottom: 28px;
}
.outpatientContText {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  line-height: 26px;
  font-weight: 400;
  margin-top: 20px;
}
.intro {
  font-size: 20px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 66px;
  margin-bottom: 28px;
}
.a {
  position: relative;
  z-index: 1;
}
.el-icon-caret-right {
  color: #ffffff;
  margin-left: -20px;
}
.outpatientImg .line {
  font-size: 14px;
  color: #767b8d;
  letter-spacing: 0;
  text-align: center;
  line-height: 26px;
  font-weight: 200;
  margin-top: 10px;
}
.outpatientConBox li {
  font-size: 16px;
  margin-bottom: 16px;
  /* margin-top: 30px; */
  color: #3d455f;
  letter-spacing: 0;
  font-weight: 400;
}
.outpatientConBox li span {
  color: #0f1422;
  font-weight: 500;
}
.trait {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  text-align: center;
  font-weight: 400;
  justify-content: space-between;
}
.traits {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
  justify-content: space-between;
}
/* .trait:after {
  content: "";
  width: 50%;
} */
/* .traits:after {
  content: "";
  width: 50%;
} */
.traits li {
  width: 20%;
}
.nursing {
  text-indent: 1em;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 400;
  margin-top: 16px;
}
.nursing span {
  color: #29324c;
}
.tabsCont >>> .el-tabs__header {
  /* width: 22% !important; */
  background-color: #ffffff;
  padding-top: 120px;
}
.tabsCont >>> .el-tabs__content {
  border-left: #f5f7fa 8px solid;

  background-color: #ffffff;
}
.tabsCont >>> .el-radio-group {
  margin: 0;
}
.tabsCont >>> .el-tabs__item {
  text-align: left;
  font-size: 16px;
  color: #0f1422;
  letter-spacing: 0;
width: 95%;
  font-weight: 400;
}
.tabsCont >>> .el-tabs__item.is-active {
  text-align: left;
  font-size: 16px;
 width: 95%;
  background-color: #e52f22;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
.tabsCont >>> .el-tabs__item {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/views/operaing/index.vue